import { ENDPOINT_ACTIONS, ENDPOINT_ACTIONS_BY_REGION_PLAN, ENDPOINT_REPORTS } from '@/common/constants';
import { HttpApi } from '@/common/http';
import { create } from 'zustand';
import { IAction, TReport } from '../model/IReport';

const httpApi = new HttpApi();

export const useReportStore = create<TReport>((set) => ({
  actions: [],
  actionsByRegionPlan: [],
  actionsLoading: false,
  actionsByRegionPlanLoading: false,
  reportsLoading: false,
  fetchActions: async (params?: { plant_id: string; region_id: string }) => {
    set({ actionsLoading: true });
    const res = await httpApi.get<IAction[]>(ENDPOINT_ACTIONS, params || {});
    set({
      actions: res?.map((item) => ({
        value: item.id,
        label: item.name,
      })),
    });
    setTimeout(() => {
      set({ actionsLoading: false });
    }, 300);
  },
  fetchActionsByRegionPlan: async (params: { plant_id: string; region_id: string }) => {
    set({ actionsByRegionPlanLoading: true });
    const res = await httpApi.get<IAction[]>(ENDPOINT_ACTIONS_BY_REGION_PLAN, params);
    const unique = res
      ?.filter((item, index, arr) => arr.findIndex((i) => i.id === item.id) === index)
      ?.map((item) => ({ value: item.id, label: item.name }));
    set({ actionsByRegionPlan: unique || [] });
    setTimeout(() => {
      set({ actionsByRegionPlanLoading: false });
    }, 300);
  },
  fetchReports: async (params: any) => {
    try {
      set({ reportsLoading: true });

      const res = await httpApi.post(ENDPOINT_REPORTS, params.data);

      const base64 = res?.base64;
      if (base64) {
        const byteCharacters = atob(base64);
        const byteNumbers = Array.from(byteCharacters, (char) =>
          char.charCodeAt(0),
        );
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });

        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'Hisobot.xlsx';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
        params.setOpen(false);
      }
    } catch (err) {
      console.error('Report generation error:', err);
    } finally {
      setTimeout(() => {
        set({ reportsLoading: false });
      }, 300);
    }
  },
  resetStore: () => {
    set({
      actions: [],
      actionsByRegionPlan: [],
      actionsLoading: false,
      actionsByRegionPlanLoading: false,
      reportsLoading: false,
    });
  },
}));
